var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SConfirmDialog',{attrs:{"message":`${_vm.$t('docs.bulk_actions.delete_pdf_question')}`},on:{"confirmation-callback":_vm.onDeleteAction},model:{value:(_vm.showDialog),callback:function ($$v) {_vm.showDialog=$$v},expression:"showDialog"}})
}
var staticRenderFns = []

export { render, staticRenderFns }